import { state } from "component/molecules/viewport/toolStates/store.js";
import CustomEvent from "core/customEvent/index";
import BaseBrushTool from "component/molecules/viewport/tools/annotation/base/BaseBrushTool";
import onImageRenderedBrushEventHandler from "./onImageRenderedBrushEventHandler";
/**
 * @description ImageRendered 메세지 발생시 처리 핸들러
 * @method handleImageRendered
 *
 * @param {*} evt
 */
const handleImageRendered = function(evt) {
  const eventData = evt.detail;
  const element = eventData.element;

  // Render Annotation Tools
  const toolsToRender = state.tools.filter(
    tool => tool.element === element
    // tool =>
    //   tool.element === element &&
    //   (tool.mode === "active" ||
    //     tool.mode === "passive" ||
    //     tool.mode === "enabled")
  );

  ///
  /// Render Drawing Brush Tool
  ///
  const brushTools = toolsToRender.filter(
    tool => tool instanceof BaseBrushTool
  );

  if (brushTools.length > 0) {
    /// very very slow T.T
    //onImageRenderedBrushEventHandler(evt);
    new Promise((resolve, reject) => {
      onImageRenderedBrushEventHandler(evt);
      resolve();
    });
  }
  //-------------------------------------------

  // console.log("eventData: ", eventData);
  // console.log("element: ", element);
  // console.log("toolsToRender: ", toolsToRender);
  // console.log("brushTools: ", brushTools);

  toolsToRender.forEach(tool => {
    if (tool.renderToolData) {
      //tool.renderToolData(evt);
      new Promise((resolve, reject) => {
        // if (tool.name === "ReferenceLines") {
        //   resolve();
        // } else {
        //   tool.renderToolData(evt);
        // }
        tool.renderToolData(evt);
        resolve();
      });
    }
  });
};

/**
 * @function activate
 * @description IMAGE_RENDERED 이벤트에 대한 디스패처를 활성화
 * @param {*} element
 */
const activate = function(element) {
  element.addEventListener(
    CustomEvent.EVENTS.IMAGE_RENDERED,
    handleImageRendered
  );
};

/**
 * @function deactivate
 * @description IMAGE_RENDERED 이벤트에 대한 디스패처를 비활성화
 * @param {*} element
 */
const deactivate = function(element) {
  element.removeEventListener(
    CustomEvent.EVENTS.IMAGE_RENDERED,
    handleImageRendered
  );
};

export default {
  activate,
  deactivate
};
